import { Card, Col, Form, Input, Row, Typography } from "antd";
import React from "react";
const { Title } = Typography;

const Facility = ({ getChildData }) => {
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid phone number."));
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Facility Information
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col span={24}>
          <label className="font-medium text-[0.813rem] mb-4 flex">At which facility did the patient receive care?</label>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="ffacilityname"
            label="Facility Name/Doctor Name"
            onChange={(e) => callparent(e.target.value, "ffacilityname")}
            rules={[{ required: true, max: 100, message: "Please enter facility Name/doctor Name." }]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}></Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Facility Email"
            name="Facility_Email"
            onChange={(e) => callparent(e.target.value, "Facility_Email")}
            rules={[
              { max: 100, message: "Please enter facility email." },
              {
                type: "email",
                message: "Please enter valid email.",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fphone"
            className="font-medium"
            label="Facility Phone Number"
            onChange={(e) => callparent(e.target.value, "FacilityPhoneNumber")}
            rules={[
              { max: 20, message: "Please enter phone number." },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="faddress1"
            label="Address Line 1"
            onChange={(e) => callparent(e.target.value, "FacilityAddressLine1")}
            rules={[{ required: true, max: 150, message: "Please enter address." }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="faddress2"
            className="font-medium"
            label="Address Line 2"
            onChange={(e) => callparent(e.target.value, "FacilityAddressLine2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fcity"
            label="City"
            onChange={(e) => callparent(e.target.value, "FacilityCity")}
            rules={[{ required: true, max: 50, message: "Please enter city name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fstate"
            label="State"
            onChange={(e) => callparent(e.target.value, "FacilityState")}
            rules={[{ required: true, message: "Please enter state name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fzipcode"
            label="Zip Code"
            onChange={(e) => callparent(e.target.value, "FacilityZipCode")}
            rules={[
              {
                max: 8,
                required: true,
                message: "Please enter ZIP code.",
              },
              {
                pattern: /^[0-9]+$/, // Ensure only numeric characters
                message: "ZIP code must be numeric.",
              },
              {
                min: 5, // Minimum length of 5 characters
                message: "ZIP code must be at least 5 digits long.",
              },
            ]}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default Facility;
